export default {
    path: 'stat_list',
    name: 'stat_list',
    component: r => require.ensure([], () => r(require('./index.vue')), 'stat_list'),
    redirect: {name: 'stat_list_index'},
    children: [
        {
            path: 'stat_list_index',
            name: 'stat_list_index',
            component: r => require.ensure([], () => r(require('./list.vue')), 'stat_list_index'),
        }
    ]
}
